var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui-button circle-button change-button edit-button",
    width: "100%",
    height: "100%",
    viewBox: "0 0 125 125",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "interior-background",
    d: "M18.294,18.318c24.391,-24.391 63.996,-24.391 88.388,0c24.391,24.392 24.391,63.997 -0,88.388c-24.392,24.392 -63.997,24.392 -88.388,0c-24.392,-24.391 -24.392,-63.996 -0,-88.388Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.294,18.318c24.391,-24.391 63.996,-24.391 88.388,0c24.391,24.392 24.391,63.997 -0,88.388c-24.392,24.392 -63.997,24.392 -88.388,0c-24.392,-24.391 -24.392,-63.996 -0,-88.388Zm11.785,11.785c17.887,-17.887 46.931,-17.887 64.818,0c17.887,17.887 17.887,46.931 -0,64.818c-17.887,17.887 -46.931,17.887 -64.818,0c-17.887,-17.887 -17.887,-46.931 -0,-64.818Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.971,89.029l5.893,-17.678l11.785,11.785l-17.678,5.893Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.81,68.405l11.785,11.785l38.302,-38.302l-11.785,-11.785l-38.302,38.302Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEdit);
export default __webpack_public_path__ + "static/media/button-edit.9d3bdcdb.svg";
export { ForwardRef as ReactComponent };